import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {css} from '@emotion/react'

const TITLE = "evoApps Anmeldung"
const TOOLBAR_HEIGHT = '40px'

const cssRoot = css`
	flex-grow: 1;
	min-height: ${TOOLBAR_HEIGHT};
	max-height: ${TOOLBAR_HEIGHT};
`

interface Props {
	title?: string
}

export const TopNavBar = React.memo(({title}: Props) => {
	const cssToolbar = css`
		min-height: ${TOOLBAR_HEIGHT};
		max-height: ${TOOLBAR_HEIGHT};
		background: rgb(55, 103, 152);
	`
	const cssTitle = css`
		position: fixed;
		width: 100%;
	`

	return (
		<AppBar position={'fixed'} color={'primary'} css={cssRoot}>
			<Toolbar variant={'dense'} css={cssToolbar}>
				<Typography variant="h6" align={'center'} css={cssTitle}>{title || TITLE}</Typography>
			</Toolbar>
		</AppBar>
	);
});